import React, { useContext, useEffect, useRef, useState } from 'react'
import { UserContext } from '../../../../../App';
import axios from 'axios';
import { LoadingOverlay } from '../../../../loading';
import { useCheckout } from '../../functions/useCheckout';

const ModalAddress = ({ address, setAddress, openServicePoints, setOpenAddress }) => {
  const [addresses, setAddresses] = useState([]);
  const { user } = useContext(UserContext)
  const { load, error_address, setError_Address, updateAddress } = useCheckout(address);
  const line1Ref = useRef(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      requestAnimationFrame(() => {
        if (line1Ref.current) {
          line1Ref.current.focus();
        }
      });
    }, 200);
    return () => clearTimeout(timer);
  }, [])

  async function saveAddress() {
    if (typeof address !== 'undefined') {
      if (typeof user !== 'undefined' && user.address !== address) {
        await updateAddress(address)
      }
      setOpenAddress(false)
    } else {
      setError_Address('Indtast din adresse')
    }
  }

  function updateFields(address) {
    setAddresses([])
    if (address.etage !== null) {
      if (address.dør !== null) {
        line1Ref.current.value = address.adresseringsvejnavn + ' ' + address.husnr + ', ' + address.etage + '. ' + address.dør
      } else {
        line1Ref.current.value = address.adresseringsvejnavn + ' ' + address.husnr + ', ' + address.etage + '.'
      }
    } else {
      line1Ref.current.value = address.adresseringsvejnavn + ' ' + address.husnr
    }
    document.getElementById('postal_code').value = address.postnr
    document.getElementById('city').value = address.postnrnavn
    setAddress({
      'line1': line1Ref.current.value,
      'postal_code': address.postnr,
      'city': address.postnrnavn
    })
  }

  function getAddresses(query) {
    setError_Address('')
    if (query !== '') {
      axios.get(`https://api.dataforsyningen.dk/adresser/autocomplete?q=${query}&type=adresse`, {
      })
      .then(response => {
        setAddresses(response.data);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }

  return (
    <div className="bookDetails h-full w-full flex flex-col gap-y-4 md:gap-y-6 p-8">
      {load ?
        <LoadingOverlay />
      :
        ""
      }
      <h3 className="text-xl md:text-2xl font-bold">Indtast din addresse</h3>
      <div className="flex flex-col gap-4 md:gap-6">
        <div className="title w-full flex flex-col gap-2">
          <p className="font-medium">Gadenavn</p>
          {(error_address !== '') ? <h2 className="text-sm font-medium text-red-500">{error_address}</h2> : ""}
          <div className="w-full relative group">
            <input type="text" autoFocus onBlur={(e) => e.target.value !== address?.line1 ? e.target.value = (typeof address !== 'undefined' ? address.line1 : "") : ""} ref={line1Ref} autoComplete='none' spellCheck='false' onChange={(e) => getAddresses(e.target.value)} defaultValue={typeof address !== 'undefined' ? address.line1 : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
            <div className={"border-l border-r border-neutral-300 z-10 absolute w-full max-h-56 overflow-auto bg-white opacity-0 group-focus-within:opacity-100 " + (addresses.length > 0 && "border-b")}>
              <ul>
                {
                  addresses.map((address) => {
                    return (
                      <li className="ps-4 py-2 hover:bg-neutral-100 cursor-pointer" onClick={() => updateFields(address.adresse)}>{address.tekst}</li>
                    )
                  })
                }
              </ul>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <div className="title w-full flex flex-col gap-2">
            <p className="flex-[1] font-medium">Postnummer</p>
            <div className="w-full flex-[1] relative">
              <input type="text" id="postal_code" autoComplete='none' disabled defaultValue={typeof address !== 'undefined' ? address.postal_code : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
            </div>
          </div>
          <div className="title w-full flex flex-col gap-2">
            <p className="flex-[1] font-medium">By</p>
            <div className="w-full flex-[1] relative">
              <input type="text" id="city" autoComplete='none' disabled defaultValue={typeof address !== 'undefined' ? address.city : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
            </div>
          </div>
        </div>
      </div>
      <button className="w-full text-sm font-medium bg-gradient-to-r from-emerald-600 to-emerald-700 transition-[] bg-size-200 bg-pos-0 hover:bg-pos-100 text-white mx-auto px-5 py-2.5" onClick={() => saveAddress()}>Gem</button>
    </div>
  )
}

export default ModalAddress